<template>
<div class="chapter">
<div class="inner_page">
<p class="p_autor"><span>Adolph Freiherr von Knigge</span></p>
<p class="p_titel"><span>Über den Umgang mit Menschen</span></p>
<p class="p_normal"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?2bb62d68